import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { FiArrowLeft } from 'react-icons/fi';
import Headings from './sub_components/Headings';
import BankAccount from './sub_components/payment/BankAccount';
import Comcard from './sub_components/payment/Comcard';
import Comchecks from './sub_components/Comchecks';
import 'react-toastify/dist/ReactToastify.css';
import { baseUrl } from '../utils.jsx/baseUrl';

// import {
//   BankAccoundICon, ComChecksIcon, ComCardIcon, Delete, Edit, RateIcon, CustomerIcon, CardNumIcon,
// } from './svg/icons/icon';
import Contextapi from '../context-api/createContext';
import DetailsOfFunding from './sub_components/payment/DetailsOfFunding';
import Loader from './sub_components/Loader';

function Fundingpayment() {
  const navigate = useNavigate();
  const [loaderflag, setLoaderFlag] = useState(false);
  const {
    paymentFlag,
    ref,
    bankaccountref,
    comcardref,
    setEditcomsflag,
    seteditcomcardflag,
    setEditbanckaccountflag,
    setBankDetails,
    setComcheckData,
    setComcardDetails,
    // setIsnavabr,
    setWarnflag,
  } = useContext(Contextapi);

  const { editbanckaccountflag, editcomsflag } = useContext(Contextapi);
const tabsDisabled = {
  fundingAccount: editcomsflag, 
  comchek: editbanckaccountflag,     
};

  const [paymentdetailflag, setPaymentdetailflag] = useState(false);
  const [borderColor1, setBorderColor1] = useState('border-b-2 border-[#258CFB]');
  const [borderColor2, setBorderColor2] = useState(null);
  const [borderColor3, setBorderColor3] = useState(null);
  const [context, setContext] = useState(<BankAccount />);

  const [height, setHeight] = useState('h-[500px]');
  const sid = sessionStorage.getItem('sid');
  const token = sessionStorage.getItem('token');
  const [fundingDetails, setFundingDetails] = useState({});
  const [comdataCard, setComdataCard] = useState([]);
  const [comchecks1, setComchecks] = useState([]);
  const [bankaccount, setBankaccount] = useState([]);
  const [Isverified, setIsverified] = useState(false);
  const [notes,setNotes] = useState('')
  const [paymentLeft , setPaymentLeft] = useState(0)
  // const [scheduleType , setScheduleType] = useState({express : false , priority : false , standard : false})

  // Authorization
  useEffect(() => {
    (async () => {
      try {
        await axios.get(`${baseUrl.url}/auth/who-am-i`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setIsverified(true);
        // setIsnavabr(true);
        setWarnflag(false);
      } catch (error) {
        console.log(error);
        navigate('/login');
      }
    })();
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      toast.warn('Please Dont Leave This Page Before Submit Your Payment ', {
        autoClose: 5000,
        position: 'top-center',
        className: 'w-[500px]',
      });
    });
    return () => clearTimeout(timer);
  }, []);
  useEffect(() => {
    (async () => {
      const url = `${baseUrl.url}/new-payment/schedule-id/${sid}`;
      try {
        const response = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${token}`,
          },

        });
        // eslint-disable-next-line max-len
        setFundingDetails(response.data);
       setPaymentLeft(response.data.payment_left)
        // eslint-disable-next-line max-len
        if (response.data && 
          // (response.data.comdata_cards.length || 
           ( response.data.comchecks.length || response.data.bank_accounts.length)) {
          // setComdataCard(response.data.comdata_cards);
          setComchecks(response.data.comchecks);
          setBankaccount(response.data.bank_accounts);
          setPaymentdetailflag(true);
        } else {
          setPaymentdetailflag(false);
        }
      } catch (error) {
        console.log(error);
      }
    })();
  }, [paymentFlag, paymentdetailflag]);



  const BankAccound = () => {
    if (borderColor2 || borderColor3) {
      setComcheckData('');
      setComcardDetails('');
      setContext(<BankAccount paymentLeft = {paymentLeft} />);
      setBorderColor2(null);
      setHeight('h-[500px]');
      setBorderColor3(null);
      setBorderColor1('border-b-2 border-[#258CFB]');
      setEditcomsflag(false);
      seteditcomcardflag(false);
      
    }
  };
  const Comcards = () => {
    if (borderColor1 || borderColor3) {
      setContext(<Comcard />);
      setBorderColor1(null);
      setBorderColor3(null);
      setHeight('h-[750px]');
      setBorderColor2('border-b-2 border-[#258CFB]');
      setEditcomsflag(false);
      setEditbanckaccountflag(false);
      setBankDetails('');
      setComcheckData('');
    }
  };
  const comchecks = () => {
    if (borderColor2 || borderColor1) {
      setBankDetails('');
      setComcardDetails('');
      setContext(<Comchecks  paymentLeft = {paymentLeft}/>);

      setBorderColor1(null);
      setBorderColor2(null);
      setHeight('h-[380px]');
      setBorderColor3('border-b-2 border-[#258CFB]');
      seteditcomcardflag(false);
      setEditbanckaccountflag(false);
     

    }
  };

 const handleScheduleComplete = async () => {
  
  setLoaderFlag(true);

  try {
    // Call peruse API first
    const peruseRes = await axios.get(
      `${baseUrl.url}/peruse/list`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const peruseData = peruseRes?.data;

    if (!peruseData?.version) {
      throw new Error('Version not found from peruse API');
    }

    // Decide URL based on version
    const completeUrl =
      peruseData.version === 'V1'
        ? `${baseUrl.url}/schedule/new-completed`
        : `${baseUrl.url}/schedule/v2/new-completed`;

    // Call schedule complete API
     const body = {
      schedule_id: sid,
      notes:notes,
      is_new: true,
      // scheduleType 
    };

    const response = await axios.post(completeUrl, body, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        // No client timeout: cover-PDF generation + merge can legitimately run
        // for minutes, and aborting the client does NOT stop the server, so a
        // false timeout could leave a schedule completing in the background
        // while the user retries it. Wait for the server's real response.
      });
      if (response.status === 200) {
        setLoaderFlag(false);
        toast.success('Schedule Completed', {
          autoClose: 1000,
        });
        navigate('/funding');
      }
  } catch (error) {
    console.error(error);
    let message;
    if (error?.response) {
      // Server replied with an error (e.g. 500). Nothing was finalized
      // server-side (no pdf_url, schedule still a draft), so retrying is safe.
      // Surface the backend's specific message (e.g. which document is damaged
      // and needs re-uploading) so the client knows exactly what to fix.
      message = error.response.data?.error || 'Something went wrong. Please try again.';
    } else if (error?.code === 'ECONNABORTED') {
      // Request timed out while generating the schedule PDF.
      message = 'The request timed out while generating the schedule. Please try again in a moment.';
    } else {
      // No response at all — network error or the server restarted mid-request.
      // Nothing was finalized; retrying is safe.
      message = 'Network error — the request did not complete. Please try again in a moment.';
    }
    toast.error(message, { autoClose: 5000 });
  } finally {
    setLoaderFlag(false);
  }
};


  // const scheduleComplete = async () => {
  //   // const noneSelected = Object.values(scheduleType).every(value => value === false);
  //   // console.log(noneSelected)
  //   // if(noneSelected){
  //   //   toast.error('Please select a schedule type', {
  //   //     autoClose: 2000,
  //   //   });
  //   //   return;
  //   // }
  //   setLoaderFlag(true);
  //   const url = `${baseUrl.url}/schedule/new-completed`;
  //   const body = {
  //     schedule_id: sid,
  //     notes:notes,
  //     is_new: true,
  //     // scheduleType 
  //   };
 
  //   try {
  //     const response = await axios.post(url, body, {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //       },

  //     });
  //     if (response.status === 200) {
  //       setLoaderFlag(false);
  //       toast.success('Schedule Completed', {
  //         autoClose: 1000,
  //       });
  //       navigate('/funding');
  //     }
  //   } catch (error) {
  //     setLoaderFlag(false);

  //     console.log(error);
  //   }
  // };


  console.log(paymentLeft,'paymentLeft in funding payment')
  return Isverified && (
    <>
      {loaderflag && <Loader />}
      <div className="w-[1168px] mx-auto mt-[45px] font-sfPro  ">
        <div className="flex justify-between items-center">

          <Headings
            heading="Payment Instructions"
            title="Enter the payment instructions
          below"
          />
          <button
            type="button"
            className="w-32 h-[38px] text-base font-normal text-[#ffffff] border flex justify-center items-center bg-slate-600 rounded-lg"
            onClick={() => {
              navigate('/funding/create_shedule');
            }}
          >
            <FiArrowLeft />
            Back
          </button>
        </div>
        <div className="w-full flex gap-9 mt-[30px]">
          {/* first col */}
          <div style={{ boxShadow: ' 0px 4px 4px rgba(0, 0, 0, 0.12)' }} className={`w-[620px] ${height} bg-[#ffffff] rounded-xl px-[36px] py-[30px] transition-all duration-200 overflow-hidden flex flex-col gap-[38px]`}>
            {/* nav toggle */}
            <div className="w-full h-auto grid grid-cols-2 ">
              <div type="button" ref={bankaccountref} role="none" 
               className={`h-full items-center flex flex-col justify-between mb-2 transition-all duration-200
    ${borderColor1} 
    ${tabsDisabled.fundingAccount ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}
  `}
              // className={` h-full items-center flex flex-col justify-between ${borderColor1} cursor-pointer transition-all duration-200 mb-2`} 
              onClick={tabsDisabled.fundingAccount ? null : BankAccound}
              title={tabsDisabled.fundingAccount ? 'Disabled while updating' : ''}
              >
                <h3 className="font-[500] text-lg text-black">Funding Account</h3>

              </div>
              {/* <div type="button" ref={comcardref} role="none" className={`w-[150.67px] h-full flex flex-col justify-between ${borderColor2} cursor-pointer  transition-all duration-100`} onClick={Comcards}>
                <h3 className="font-[500] text-base text-black">Comcard</h3>

              </div> */}
              <div type="button" ref={ref} role="none" 
              // className={` h-full items-center flex flex-col justify-between ${borderColor3} cursor-pointer  transition-all duration-100 mb-2`} onClick={tabsDisabled ? null : comchecks}

               className={`h-full items-center flex flex-col justify-between mb-2 transition-all duration-100
    ${borderColor3} 
    ${tabsDisabled.comchek ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}
  `}
  onClick={tabsDisabled.comchek ? null : comchecks}
  title={tabsDisabled.comchek ? 'Disabled while updating' : ''}
              >
                <h3 className="font-[500] text-lg text-black">Comchek</h3>

              </div>


              

            </div>
            {context}
  
              
          </div>

          

          {/*  2nd col  */}
         
        
          <div className="w-[514px] flex  flex-col gap-[28px]  ">
            {/* first row div */}
            {/* outer dib\v */}

             {/* <div style={{ boxShadow: ' 0px 4px 4px rgba(0, 0, 0, 0.12)' }}  className = "flex flex-col gap-3 w-full h-[100px] rounded-xl bg-white  px-[26px] py-[20px]">
          <div className = "font-[500] text-base text-black">Processing Options</div>
            <div className = "flex flex-row ">
              <div className="w-full h-[24px]  gap-[13px] flex items-center ">
          <input onChange={() => { setScheduleType({priority : false , standard : false,  express : true}) }} type="radio" id="radio" name="express" value="Bank Account" checked={scheduleType.express}  /> 

            <p className="font-normal text-base text-[#000000]">Express <span className = 'text-xs'>(~2 Hrs)</span></p>
          </div>
          <div className="w-full h-[24px] flex  gap-[13px] items-center">
             <input onChange={() => { setScheduleType({priority : true , standard : false,  express : false}) }} type="radio" id="radio" name="priority" value="Priority" checked={scheduleType.priority} /> 

            <p className="font-normal text-base text-[#000000]">Priority <span className = 'text-xs'>(Same Day)</span></p>
          </div>

           <div className="w-full h-[24px] flex  gap-[13px] items-center">
             <input onChange={() => { setScheduleType({priority : false , standard : true,  express : false}) }} type="radio" id="radio" name="standard" value="Standard" checked={scheduleType.standard} /> 

            <p className="font-normal text-base text-[#000000]">Standard <span className = 'text-xs'>(ACH)</span></p>
          </div>

            </div>
            </div> */}
            {paymentdetailflag && <DetailsOfFunding 
            // comdataCard={comdataCard} 
            comchecks1={comchecks1} bankaccount={bankaccount} />}

            {/* 2nd row */}
            <div
              style={{
                boxShadow: ' 0px 4px 4px rgba(0, 0, 0, 0.12)',
              }}
              className="w-full h-[276.16px] mb-11 bg-[#ffffff] rounded-xl px-[36px] py-[30px] flex flex-col justify-between"
            >
              {/* innner div  */}
              <div className="w-full h-[107.16px]  flex">
                <div className="w-[50%] h-full  flex flex-col  justify-between">
                  <p className="font-[500] text-base text-black">Total Fund:</p>
                  <p className="font-[500] text-base text-black">Advances/Deductions:</p>
                  <p className="font-[500] text-base text-black">Balance fund:</p>

                </div>
                <div className="w-[50%] h-full  flex flex-col justify-between text-right">
                  <p className="font-normal text-base text-black">
                    $
                    {fundingDetails.total_fund}
                  </p>
                  <p className="font-normal text-base text-black">
                    $
                    {fundingDetails.advance}
                  </p>
                  <p className="font-normal text-base text-black">
                    $
                    {fundingDetails.payment_left}
                  </p>

                </div>
              </div>
              <textarea className='border border-slate-300  p-2 my-2 text-base' rows={'4'} cols={'50'} placeholder='Add notes' value={notes} onChange={()=>{
                setNotes(event.target.value)
              }}></textarea>
             
              <button
                type="submit"
                onClick={handleScheduleComplete}
                className={`font-sfPro leading-5  w-[102px] h-[53px] rounded-xl  ${fundingDetails.payment_left !== 0 ? ' bg-slate-300' : 'bg-[#258CFB]'} flex items-center justify-center font-[500] text-lg text-[#ffffff] `}
                disabled={fundingDetails.payment_left !== 0}
              >
                Submit

              </button>

            </div>

          </div>

        </div>
      </div>
      <ToastContainer />
    </>

  );
}

export default Fundingpayment;
